module.exports = __webpack_public_path__ + "static/media/badges.c02c2fc3.png";